import { Component, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormulaValidationService } from '@module-definition/formulas/cipo-formula/formula-validation.service';
import { FormulaField } from '@module-definition/formulas/cipo-formula/formula.model';
import jsonLogic from '@module-definition/formulas/cipo-formula/json-logic-operators.service';
import { TranslateService } from '@ngx-translate/core';
import { CipoDialogHeaderComponent } from '@shared/dialogs';
import { CipoFormModule } from '@shared/modules/forms.module';

@Component({
  selector: 'cipo-formula-test-dialog',
  templateUrl: './formula-test-dialog.component.html',
  styleUrls: ['./formula-test-dialog.component.scss'],
  standalone: true,
  imports: [
    CipoFormModule,
    MatCardModule,
    MatChipsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    CipoDialogHeaderComponent,
  ],
})
export class FormulaTestDialogComponent {
  dialog = inject(MatDialog);
  readonly dialogRef = inject(MatDialogRef<FormulaTestDialogComponent>);

  private formulaValidationService = inject(FormulaValidationService);
  private translate = inject(TranslateService);
  dialogData = inject<{
    formula: string;
    usedFieldIds: number[];
    fieldOptions: FormulaField[];
    fieldDetailsMap: Map<number, FormulaField>;
  }>(MAT_DIALOG_DATA);

  testFieldValues: { [key: number]: FormControl } = {};
  testResult: any = null;
  testError: string | null = null;

  constructor() {
    this.dialogData.usedFieldIds.forEach(fieldId => {
      this.testFieldValues[fieldId] = new FormControl('');
    });

    console.log('usedFieldIds', this.dialogData.usedFieldIds);
    console.log('fieldOptions', this.dialogData.fieldOptions);
    console.log('fieldDetailsMap', this.dialogData.fieldDetailsMap);
  }

  executeTest() {
    if (!this.dialogData.formula) return;

    try {
      const testData: { [key: string]: any } = {};
      Object.keys(this.testFieldValues).forEach(fieldIdStr => {
        const fieldId = Number(fieldIdStr);
        const value = this.testFieldValues[fieldId].value;
        let processedValue;
        if (value === 'true') processedValue = true;
        else if (value === 'false') processedValue = false;
        else if (!isNaN(Number(value)) && value !== '') processedValue = Number(value);
        else processedValue = value;

        const label = this.dialogData.fieldDetailsMap.get(fieldId)?.label || fieldId;
        testData[label] = processedValue;
      });

      const validationResult = this.formulaValidationService.validateFormula(
        this.dialogData.formula || '',
        this.dialogData.fieldOptions,
        //this.dialogData.fieldDetailsMap,
      );

      if (validationResult.isValid && validationResult.jsonLogicObj) {
        this.testResult = jsonLogic.apply(validationResult.jsonLogicObj, testData);
      }
      this.testError = null;
    } catch (e: any) {
      this.testError = this.translate.instant('formulas.errors.testExecutionFailed', { error: e.message || e });
      this.testResult = null;
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
